export const emptyDashboard = {
  id: null,
  name: null,
  useCase: null,
  description: null,
  territories: [],
  jobType: null,
}
